import JwtService from "@/core/services/jwt.service";
import ApiService from "@/core/services/api.service";
import { postRedirectMessage } from "@/components/IFrame/iframehelper";

class BaseAuth {
  verify() {
    let returnData = {
      success: false,
      user: "",
      token: ""
    };
    const token = JwtService.getToken();
    if (token) {
      returnData.token = token;
      returnData.success = true;
    } else {
      JwtService.destroyToken();
    }
    return returnData;
  }

  handleLogout() {
    // reset user data
    postRedirectMessage("login");
    localStorage.removeItem("selectedProjectData");
    // completely remove the persistent states in the store
    localStorage.removeItem("vuex");
    ApiService.removeAllHeaders();
  }

  useAuth0() {
    return process.env.VUE_APP_AUTH0_ACTIVE === "true";
  }
}

export default new BaseAuth();
